/* import __COLOCATED_TEMPLATE__ from './u16-state-results-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class U17StateResultsCardComponent extends Component 
{
	get resultsFiltered()
	{
		const classGroupId = this.args.classGroupId || this.args.classGroup.id;
		const club = this.args.club;
		return this.args.results.filter((result) =>
		{
			return (result.status == "OK") && (result.place != "") && (result.ClassGroupId == classGroupId) && (result.club == club);
		});
	}

	get totalPoints()
	{
		let total = 0;
		const filtered = this.resultsFiltered;
		
		filtered.forEach(function(result)
		{
			total+=result.pointsU16Team;
		})
		return total;
	}
	
	sortFn(a,b)
	{
		return a.pointsU16Team > b.pointsU16Team;
	}
}
